<template>
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <div class="font-weight-bold">
                Métodos de Pagamento
            </div>
            <b-button @click="canShow = !canShow" variant="default" size="sm">
                <i class="fas fa-minus" v-if="canShow"></i>
                <i class="fas fa-plus" v-else></i>
            </b-button>
        </div>
        <div class="card-body" v-show="canShow">
            <!-- List -->
            <cards-show v-if="card" :card="card" />

            <!-- Empty -->
            <cards-empty v-else />

            <!-- Add -->
            <b-button variant="primary" @click="openModalAddCard">
                {{ card ? 'Atualizar' : 'Adicionar' }}
            </b-button>

            <!-- Add Form Modal -->
            <cards-form :pagarme-key="pagarmeKey" @added="loadCard" />
        </div>
    </div>
</template>

<script>
import CardsEmpty from './Empty';
import CardsShow from './Show';
import CardsForm from './Form';

export default {
    props: {
        pagarmeKey: {
            type: String,
            required: true,
        }
    },
    components: {
        CardsEmpty,
        CardsShow,
        CardsForm,
    },
    data() {
        return {
            loading: false,
            card: null,
            canShow: false,
        }
    },
    created() {
        this.loadCard();
    },
    methods: {
        async loadCard() {
            this.loading = true;

            await axios.get('/teacher/pagarme/card')
                .then((response) => {
                    this.card = response.data.data.card || null;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        openModalAddCard() {
            this.$bvModal.show('modal-add-card');
        }
    }
}
</script>

<style scoped>

</style>
